import Modal from '../../../components/Modal/Modal';
import { INSURANCE_ID } from '../../../constants';
import Services from '../../Services/Services';

const DealCreateServicesModal = ({ isOpen, onClose, onSubmit, onCancel, paymentType, orderId, cityId, enableInsurance }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onCancel}>
      <Services header={false} onSubmit={onSubmit} onCancel={onCancel} paymentType={paymentType} edit={false} submitButtonLabel="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÑÑÐ»ÑÐ³Ð¸" orderId={orderId} withCheckboxes requiredCheckboxes={[INSURANCE_ID]} cityId={cityId} enableInsurance={enableInsurance} addServiceInModal/>
    </Modal>
  );
};

export default DealCreateServicesModal;
